import { SaleOrder } from "../../../state/types"
import { SalePDFPage } from './salePDFPage'
import { ItemsPDFWrapper } from '../../../../../features/ui'
import { CodedDataType } from '../../../../../tables'
import { Item } from "../../../../operations"

type Props = {
    id: string
    sale: SaleOrder
    previewMode?: boolean
}

export const SalePDF = (props: Props) => {
    const { id, sale, previewMode } = props

    const renderPDFPage = (
        pageIndex: number,
        dataType: CodedDataType,
        items: Item[],
        pagesAmount: number
    ) => (
        <SalePDFPage
            pageIndex={pageIndex}
            sale={dataType as SaleOrder}
            items={items}
            pagesAmount={pagesAmount}
        />
    )

    return (
        <ItemsPDFWrapper
            id={id}
            dataType={sale}
            items={sale.items}
            previewMode={previewMode}
            renderPDFPage={renderPDFPage}
        />
    )
}
